import request from "../../../util/request"
import { PHP_API_URL} from "../../../util/constants";
import Cookies from 'js-cookie'

export function getCardInfoListRequest( callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('caozuo',"get_ai_shoucang_list");
    formData.append('namekey', "");
    formData.append('username', Cookies.get('username'));;
    
    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function getVideoPlayerAuthRequest(VideoId, callback) {
    let formData = new FormData();
    // formData.append('caozuo', "xuexi_shiti");
    formData.append('VideoId', VideoId);
    return request(PHP_API_URL+"/aliyun/getplayauth.php", {
        method: "POST",
        body: formData
    }, callback);
}

export function getAppToken(app_code,channel, callback) {
    return request("/ygbh/getAppToken", {
        method: "POST",
        body: {
            "userToken":Cookies.get("userToken"),
            "app_code":app_code,
            'channel':channel
        }
    }, callback);
}


export function updateAppLogRequest(paramers, callback) {
    let formData = new FormData();
    formData.append('yingyong_type',"2");
    formData.append('app_code', paramers.code);
    formData.append('app_name', paramers.title);
    formData.append('app_jifen', paramers.jifen);
    formData.append('username', Cookies.get('username'));;
    formData.append('user_type', Cookies.get('type'));
    formData.append('school_code', Cookies.get('school_code')=="null"?"":Cookies.get('school_code'));
    return request(PHP_API_URL+"/AppJiFei/app_userlog", {
        method: "POST",
        body: formData
    }, callback);
}